export const EyeIcon = () => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		className="fill-secondary"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_696_20818)">
			<path d="M2.09697 12C3.53797 16.08 7.42897 19 12 19C16.57 19 20.46 16.08 21.902 12C20.461 7.92 16.57 5 12 5C7.42997 5 3.53797 7.92 2.09697 12ZM0.0889668 11.696C1.69997 6.654 6.42097 3 12 3C17.58 3 22.302 6.654 23.91 11.696L24.008 12L23.911 12.304C22.3 17.346 17.578 21 12 21C6.41997 21 1.69797 17.346 0.0899668 12.304L-0.0090332 12L0.0889668 11.696ZM12 9C11.2043 9 10.4413 9.31607 9.87865 9.87868C9.31604 10.4413 8.99997 11.2044 8.99997 12C8.99997 12.7956 9.31604 13.5587 9.87865 14.1213C10.4413 14.6839 11.2043 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM6.99997 12C6.99997 10.6739 7.52675 9.40215 8.46443 8.46447C9.40211 7.52678 10.6739 7 12 7C13.326 7 14.5978 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5978 16.4732 13.326 17 12 17C10.6739 17 9.40211 16.4732 8.46443 15.5355C7.52675 14.5979 6.99997 13.3261 6.99997 12Z" />
		</g>
		<defs>
			<clipPath id="clip0_696_20818">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
